import { translationsKeyList } from '~/models';

export function buildTranlationsQueryParams(): string {
  return translationsKeyList
    .reduce((queryParamString, key) => `${queryParamString}Keys=${key}&`, '')
    .slice(0, -1);
}
